import * as React from 'react';
import { Textarea as HenTextarea } from '@highereducation/hen-ui';
import { fieldName } from '../submit';
import {
  FieldLabel,
  FieldErrorMessage,
  type FieldComponentProps,
} from './parts';

/** Multi-line TEXTAREA field. */
export function TextareaField({ field, formId, error }: FieldComponentProps) {
  const name = fieldName(formId, field.id);

  return (
    <>
      <FieldLabel field={field} htmlFor={name} />
      <HenTextarea
        id={name}
        name={name}
        placeholder={field.placeholder}
        required={Boolean(field.isRequired)}
        error={Boolean(error)}
      />
      <FieldErrorMessage error={error} />
    </>
  );
}
